/* eslint-disable @typescript-eslint/no-explicit-any */

// Gemeinsamer Renderer (wie dein "h")
function h(tag: string | ((props: any) => any), props: Record<string, any> | null, ...children: any[]): string {
    if (typeof tag === 'function') {
        // Custom-Komponenten
        return tag({ ...props, children });
    }

    const attrs = props
        ? Object.entries(props)
              .map(([k, v]) => {
                  if (v == null || v === false) return '';

                  // class-Objekt → "class-a class-b"
                  if (k === 'class' && typeof v === 'object' && !Array.isArray(v)) {
                      v = Object.entries(v)
                          .filter(([_, val]) => Boolean(val))
                          .map(([key]) => key)
                          .join(' ');
                  }

                  // style-Objekt → "color:red;font-size:12px"
                  if (k === 'style' && typeof v === 'object' && !Array.isArray(v)) {
                      v = Object.entries(v)
                          .map(([prop, val]) => `${prop}:${val}`)
                          .join(';');
                  }

                  // data-/aria-Objekte
                  if ((k.startsWith('data-') || k.startsWith('aria-')) && typeof v === 'object' && !Array.isArray(v)) {
                      return Object.entries(v)
                          .map(([dataKey, dataVal]) => {
                              if (dataVal == null || dataVal === false) return '';
                              if (dataVal === true) return ` ${k}${dataKey}`;
                              return ` ${k}${dataKey}="${String(dataVal).replace(/"/g, '&quot;')}"`;
                          })
                          .join('');
                  }

                  // Boolean true → nur Attribut
                  if (v === true) return ` ${k}`;

                  // Standard-Attribut
                  return ` ${k}="${String(v).replace(/"/g, '&quot;')}"`;
              })
              .join('')
        : '';

    const inner = children.flat(Infinity).map(normalizeChild).join('');
    return `<${tag}${attrs}>${inner}</${tag}>`;
}

function normalizeChild(child: any): string {
    if (child == null || child === false) return '';
    if (Array.isArray(child)) return child.map(normalizeChild).join('');
    if (typeof child === 'string') return child;
    return String(child);
}

// === Runtime-Exports (React-kompatibel) ===

// normal JSX (<div />)
export function jsx(tag: any, props: any, key?: any) {
    const { children, ...rest } = props ?? {};
    return h(tag, rest, ...(Array.isArray(children) ? children : [children]));
}

// JSX mit mehreren Kindern (<>a{b}{c}</>)
export function jsxs(tag: any, props: any, key?: any) {
    const { children, ...rest } = props ?? {};
    return h(tag, rest, ...(Array.isArray(children) ? children : [children]));
}

// <>...</>
export function Fragment({ children }: { children: any[] }) {
    return children.flat(Infinity).map(normalizeChild).join('');
}

export function jsxDEV(tag: any, props: any, key?: any, isStaticChildren?: boolean, source?: any, self?: any) {
    const { children, ...rest } = props ?? {};
    return h(tag, rest, ...(Array.isArray(children) ? children : [children]));
}
